import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { transferStopListColumnsConfigs } from '../../../enums/columnsConfigs';
import { prepareTableData } from '../../../features/routeDetail/model';
import { getRouteDetail } from '../../../store/selectors/route';
import stopListColumns from '../../RouteDetail/StopList/stopListColumns';

const AffectedStopsTableProps = (headerCellClasses, bodyCellClasses, stops) => {
  const selectedStops = stops;
  const route = useSelector(getRouteDetail);

  return useMemo(
    () => ({
      columns: stopListColumns({
        route,
        columnsConfigs: transferStopListColumnsConfigs,
        headerCellClasses,
        bodyCellClasses,
      }),
      data: prepareTableData(selectedStops),
    }),
    [headerCellClasses, bodyCellClasses, selectedStops, route]
  );
};

export default AffectedStopsTableProps;
